import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Chart, registerables } from 'chart.js/auto';
import 'chartjs-plugin-datalabels';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import {
  LoginModel,
  MainDepartment,
} from 'src/app/Models/ApplicationModels';
import { MasterDataSeriveService } from 'src/app/Services/master-data-serive.service';
import { ReportsV3ApiService } from 'src/app/rcs/admin-module/admin-dashboard/reports-v3/services/reports-v3-api.service';
import { BreadcrumbService } from 'src/app/Services/breadcrumb.service';

@Component({
  selector: 'app-prod-overview-dashboard-v3',
  templateUrl: './production-overview-dashboard-v3.component.html',
  styleUrls: ['./production-overview-dashboard-v3.component.css'],
})
export class ProdOverviewDashboardV3Component {
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  @ViewChild('empElement') empElement!: ElementRef<HTMLElement>;
  // No store filter — matches legacy's production-overview, which never exposed one:
  // a production terminal already belongs to one store, so storeId always stays 0.
  storeId: any = 0;
  // Single-select, matching legacy's one-department-at-a-time dropdown (dashboard.component.ts
  // selectAllDepartments/setFilterNames) — the V3 API's DepartmentId is a single int, not a list.
  defaultDept: number = 0;
  startDate: any;
  endDate: any;
  private charts: Chart[] = [];
  userInfo: LoginModel = new LoginModel();
  mainDepartmentList: Array<MainDepartment> = [];
  dashboardDetails: any;
  getDetailsObj: any = {};
  isNoDataFound: boolean = false;
  isTableData: boolean = false;
  isDeptData: boolean = false;
  isEmpData: boolean = false;
  isBrandData: boolean = false;
  isFormatData: boolean = false;
  isSpecialPriceData: boolean = false;
  qtyTotal: number = 0;
  deptQty: number = 0;
  deptPrice: number = 0;
  empQty: number = 0;
  formatQty: number = 0;
  specialPriceQty: number = 0;
  barChartData: Array<any> = [];
  barChartLabels: Array<any> = [];
  printLabels: any;
  isSingleStore: boolean = false;
  @Input() max: any;
  maxDate = new Date();
  tableDataTotalQty: number = 0;
  public daterange: any = {};
  deptName: string = 'All Departments';
  dashboardTabledata: any = [];
  StoreNames: string | any = [];
  tempToggleOption: number = 1;
  sortDirection: string = 'asc';
  isLoading: boolean = false;
  reportHasRun: boolean = false;
  mainStats = {
    qty: 0,
    price: 0,
    categoryCnt: 0,
  };

  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  // Not user-adjustable here (no Week Color filter, matching legacy) — always 0, kept only
  // because getProductionOverviewDashboardV3/TableV3 require the positional argument.
  productionCycleId: number = 0;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private datepipe: DatePipe,
    private masterservice: MasterDataSeriveService,
    private reportsV3Service: ReportsV3ApiService
  ) {
    this.maxDate.setDate(this.maxDate.getDate());
  }

  async ngOnInit() {
    this.breadcrumbService.updateActiveDeptTab('Dashboard');
    this.breadcrumbService.updateActiveCategoryTab('Production Overview');
    this.startDate = moment();
    this.endDate = moment();
    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    this.getMainDepartments();
  }

  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,
    maxDate: new Date(),
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
    },
    opens: 'left',
  };

  public selectedDate(value: any, datepicker?: any) {
    this.endDate = value.end._d;
    this.startDate = value.start._d;
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.daterange.start = value.start;
    this.daterange.end = value.end;
    this.daterange.label = value.label;
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  sortByDepartment(col: string) {
    if (col === 'dept') {
      this.dashboardTabledata.sort(
        (a: { department: string }, b: { department: string }) => {
          if (this.sortDirection === 'asc') {
            return a.department.localeCompare(b.department);
          } else {
            return b.department.localeCompare(a.department);
          }
        }
      );
    } else {
      this.dashboardTabledata.sort((a: any, b: any) => {
        const qtyA = this.getQtyByStoreName(a, col);
        const qtyB = this.getQtyByStoreName(b, col);
        if (this.sortDirection === 'asc') {
          return qtyA - qtyB;
        } else {
          return qtyB - qtyA;
        }
      });
    }
  }

  toggleSortDirection(col: string) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortByDepartment(col);
  }

  getQtyByStoreName(data: any, storeName: string): number {
    const item = data.qty.find((qtyItem: any) => qtyItem.store === storeName);
    return item ? item.qty : 0;
  }

  getMainDepartments() {
    this.masterservice.getDepartmentsProduction(false, 0).subscribe(
      (Response: any) => {
        this.mainDepartmentList = Response as MainDepartment[];
      },
      (err) => { }
    );
  }

  updateChart() {
    this.storeId = parseInt(this.storeId);
    if (!this.isTableData) {
      this.destroyCharts();
      this.getAllDashboardDetails();
    } else {
      this.getDashboardTableDetails();
    }
  }

  // Single-select department filter, matching legacy's dashboard.component.ts exactly.
  selectAllDepartments() {
    this.deptName = 'All Departments';
    this.defaultDept = 0;
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 2) {
      this.deptName = filterObj.departmentDescr;
      this.defaultDept = filterObj.departmentId;
    }
  }

  getDashboardTableDetails() {
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.reportsV3Service
      .getProductionOverviewTableV3(
        this.userInfo.companyID,
        this.storeId || 0,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId,
        this.defaultDept || 0
      )
      .subscribe({
        next: (res: any) => {
          const storeNamesSet = new Set<string>();
          this.StoreNames = [];
          const dashboardDetail = res?.dashboardDetail ?? (Array.isArray(res) ? res : []);
          // Legacy always keys the table by employee, never by store (production-module has
          // no store filter — each terminal already belongs to one store).
          dashboardDetail.forEach((item: { userName: string }) => {
            storeNamesSet.add(item.userName);
          });
          this.StoreNames = Array.from(storeNamesSet);
          if (this.StoreNames.length === 1) {
            this.isSingleStore = true;
          }
          this.dashboardTabledata = this.formateDashboardTableData(dashboardDetail);
          this.tableDataTotalQty = this.dashboardTabledata.reduce(
            (sum: any, dep: { qty: any[] }) =>
              sum + dep.qty.reduce((total, q) => total + q.qty, 0),
            0
          );
        },
        error: (err) => {
          this.isNoDataFound = true;
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  async getAllDashboardDetails() {
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );

    this.reportsV3Service
      .getProductionOverviewDashboardV3(
        this.userInfo.companyID,
        this.storeId || 0,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId,
        this.defaultDept || 0
      )
      .subscribe({
        next: (res: any) => {
          this.dashboardDetails = res as any[];
          if (
            this.dashboardDetails.department.length === 0 &&
            this.dashboardDetails.brand.length === 0 &&
            this.dashboardDetails.emp.length === 0
          ) {
            this.isNoDataFound = true;
          } else {
            this.isNoDataFound = false;
          }

          if (res.stats.length > 0) {
            this.mainStats = res.stats[0];
          } else {
            this.mainStats = { qty: 0, price: 0, categoryCnt: 0 };
          }

          if (res.department.length === 0) {
            this.isDeptData = true;
          } else {
            this.isDeptData = false;
          }
          if (res.emp.length === 0) {
            this.isEmpData = true;
          } else {
            this.isEmpData = false;
          }
          if (res.brand.length === 0) {
            this.isBrandData = true;
          } else {
            this.isBrandData = false;
          }
          if (res.format.length === 0) {
            this.isFormatData = true;
          } else {
            this.isFormatData = false;
          }
          if (res.specialPrice.length === 0) {
            this.isSpecialPriceData = true;
          } else {
            this.isSpecialPriceData = false;
          }

          // Pivot format/print rows (Department x FormatType) into the stacked-bar shape the
          // chart needs — must run before renderChart(), which reads barChartData/barChartLabels/
          // printLabels directly rather than dashboardDetails.format.
          const uniqueDepartments: Array<any> = [];
          const formatTypes: Array<any> = [];
          this.dashboardDetails.format.forEach(
            (item: { departmentId: any; departmentDescr: any }) => {
              const existingDepartment = uniqueDepartments.find(
                (dep) => dep.departmentId === item.departmentId
              );
              if (!existingDepartment) {
                uniqueDepartments.push({
                  departmentId: item.departmentId,
                  departmentDescr: item.departmentDescr,
                });
              }
            }
          );
          this.dashboardDetails.format.forEach(
            (item: { formatTypeId: any; formatTypeDesr: any }) => {
              const existingFormat = formatTypes.find(
                (f) => f.formatTypeId === item.formatTypeId
              );
              if (!existingFormat) {
                formatTypes.push({
                  formatTypeId: item.formatTypeId,
                  formatTypeDesr: item.formatTypeDesr,
                });
              }
            }
          );
          this.barChartLabels = uniqueDepartments;
          this.printLabels = formatTypes;
          this.barChartData = [];
          for (let i = 0; i < formatTypes.length; i++) {
            const row: number[] = [];
            for (let j = 0; j < uniqueDepartments.length; j++) {
              let qtyValue = 0;
              this.dashboardDetails.format.forEach(
                (res2: { formatTypeId: any; departmentId: any; qty: any }) => {
                  if (
                    res2.formatTypeId === formatTypes[i].formatTypeId &&
                    res2.departmentId === uniqueDepartments[j].departmentId
                  ) {
                    qtyValue = res2.qty;
                  }
                }
              );
              row[j] = qtyValue;
            }
            this.barChartData[i] = row;
          }

          this.formatQty = 0;
          for (const format of this.dashboardDetails.format) {
            this.formatQty += format.qty;
          }

          this.specialPriceQty = 0;
          for (const price of this.dashboardDetails.specialPrice) {
            this.specialPriceQty += price.qty;
          }

          this.renderChart();

          if (this.dashboardDetails.department.length > 0) {
            this.deptPrice = 0;
            this.deptQty = 0;
            for (let dept of this.dashboardDetails.department) {
              this.deptQty += dept.qty;
              this.deptPrice += dept.price;
            }
          } else {
            this.deptPrice = 0;
            this.deptQty = 0;
          }
          if (this.dashboardDetails.emp.length > 0) {
            this.empQty = 0;
            for (let emp of this.dashboardDetails.emp) {
              this.empQty += emp.qty;
              if (!emp.userName) {
                emp.userName = '-';
              }
            }
          } else {
            this.empQty = 0;
          }

          if (this.dashboardDetails.brand.length > 0) {
            this.qtyTotal = 0;
            for (let brand of this.dashboardDetails.brand) {
              this.qtyTotal += brand.qty;
            }
          } else {
            this.qtyTotal = 0;
          }

        },
        error: (err) => {
          this.isDeptData = true;
          this.isEmpData = true;
          this.isBrandData = true;
          this.isFormatData = true;
          this.isSpecialPriceData = true;
          this.isNoDataFound = true;
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        },
      });
  }

  renderChart() {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);

    let deptItem = new Chart('deptItemV3', {
      type: 'bar',
      data: {
        labels: this.dashboardDetails.department.map(
          (item: { departmentDescr: any }) => item.departmentDescr
        ),
        datasets: [
          {
            label: 'No. of items',
            barThickness: 25,
            data: this.dashboardDetails.department.map(
              (item: { qty: any }) => item.qty
            ),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false, position: 'top', align: 'end', labels: { usePointStyle: true } },
          datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -23 },
        },
        layout: { padding: { bottom: 0 } },
        scales: {
          y: { beginAtZero: true, border: { display: false }, title: { display: false, text: 'No. of Items' } },
          x: { beginAtZero: true, border: { display: false }, grid: { display: false } },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });

    let productivityEmp = new Chart('productivityEmpV3', {
      type: 'bar',
      data: {
        labels: this.dashboardDetails.emp.map((item: { userName: any }) =>
          item.userName ? item.userName : '-'
        ),
        datasets: [
          {
            label: 'No. of items (Actual)',
            barThickness: 25,
            data: this.dashboardDetails.emp.map(
              (item: { qty: any }) => item.qty
            ),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false, position: 'top', align: 'end', labels: { usePointStyle: true } },
          datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -23 },
        },
        layout: { padding: { bottom: 0 } },
        scales: {
          y: { beginAtZero: true, title: { display: false, text: 'No. of items' }, border: { display: false } },
          x: { stacked: true, grid: { display: false }, border: { display: false } },
        },
        maintainAspectRatio: false,
        responsive: true,
      },
    });

    let productivityBrand = new Chart('productivityBrandV3', {
      type: 'bar',
      data: {
        labels: this.dashboardDetails.brand.map(
          (item: { brandDescr: any }) => item.brandDescr
        ),
        datasets: [
          {
            label: 'No. of items',
            barThickness: 25,
            data: this.dashboardDetails.brand.map(
              (item: { qty: any }) => item.qty
            ),
            backgroundColor: ['#95A4FC'],
            borderRadius: 8,
            borderSkipped: false,
          },
        ],
      },
      options: {
        plugins: {
          legend: { display: false, position: 'top', align: 'end', labels: { usePointStyle: true } },
          tooltip: { enabled: true },
          datalabels: { display: false, color: '#000', font: { size: 16, weight: 'bold' }, anchor: 'end', align: 'start', offset: -23 },
        },
        layout: { padding: { bottom: 0 } },
        scales: {
          x: { stacked: true, border: { display: false }, grid: { display: false } },
          y: { stacked: true, border: { display: false }, title: { display: false, text: 'No. of items' } },
        },
        maintainAspectRatio: false,
        responsive: true,
      },
    });

    let productivityFormat = new Chart('productivityFormatV3', {
      type: 'bar',
      data: {
        labels: this.barChartLabels.map((res: any) => res.departmentDescr),
        datasets: this.barChartData.map((dataRow: number[], index) => ({
          data: dataRow,
          barThickness: 25,
          label: this.printLabels[index]?.formatTypeDesr ?? '',
          backgroundColor: this.getRandomColor(),
          borderRadius: {
            bottomLeft: index === 0 ? 8 : 0,
            bottomRight: index === 0 ? 8 : 0,
            topLeft: index === this.barChartData.length - 1 ? 8 : 0,
            topRight: index === this.barChartData.length - 1 ? 8 : 0,
          },
        })),
      },
      options: {
        plugins: {
          legend: { display: false, position: 'top', align: 'end', labels: { usePointStyle: true } },
          datalabels: { display: false },
        },
        scales: {
          x: { stacked: true, grid: { display: false }, border: { display: false } },
          y: { stacked: true, border: { display: false } },
        },
        maintainAspectRatio: false,
        responsive: true,
      },
    });

    let specialPrice: any = new Chart('specialPriceV3', {
      type: 'doughnut',
      data: {
        labels: this.dashboardDetails.specialPrice.map(
          (res: any) => res.departmentDescr
        ),
        datasets: [
          {
            label: 'Item',
            data: this.dashboardDetails.specialPrice.map(
              (res: any) => res.qty
            ),
            backgroundColor: this.dashboardDetails.specialPrice.map(() =>
              this.getRandomColor()
            ),
            borderRadius: 7,
            borderWidth: 3,
          },
        ],
      },
      options: {
        cutout: '60%',
        plugins: {
          legend: { display: true, position: 'right', labels: { usePointStyle: true } },
          datalabels: { display: false },
        },
        layout: { padding: { bottom: 0, top: 10, left: 0, right: 40 } },
        scales: { x: { display: false }, y: { display: false } },
        maintainAspectRatio: false,
        responsive: true,
      },
    });

    this.charts = [
      deptItem,
      productivityEmp,
      productivityBrand,
      productivityFormat,
      specialPrice,
    ];
  }

  destroyCharts() {
    this.charts.forEach((chart) => {
      if (chart) {
        chart.destroy();
      }
    });
    this.charts = [];
  }

  getRandomColor() {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  toggleTableOrGraph(value: number) {
    if (this.tempToggleOption !== value) {
      this.tempToggleOption = value;
      if (value == 1) {
        this.isTableData = false;
      } else {
        this.isTableData = true;
      }
    }
  }

  calculateColumnTotal(store: string): number {
    const total = this.dashboardTabledata.reduce(
      (sum: any, dashboardTabledata: { qty: any[] }) => {
        // Legacy always keys by employee (item.userName), never by store.
        const storeDataArray = dashboardTabledata.qty.filter(
          (item) => item.UserName === store
        );
        const storeQty = storeDataArray.reduce(
          (storeSum, item) => storeSum + item.qty,
          0
        );
        return sum + storeQty;
      },
      0
    );
    return total;
  }

  calculateRowTotal(row: any): number {
    const rowTotal = row.reduce((total: any, qty: any) => total + qty.qty, 0);
    return rowTotal;
  }

  getDeptUserWiseQty(deptData: any, user: string): number {
    let storeDataArray = deptData.qty.filter((item: any) => item.UserName === user);
    let totalQty = storeDataArray.reduce(
      (sum: any, item: { qty: any }) => sum + item.qty,
      0
    );
    return totalQty;
  }

  formateDashboardTableData(dashboardDetails: any[]): any[] {
    return dashboardDetails.reduce((result, item) => {
      const departmentKey = item.departmentDescr;
      const categoryName = item.categoryName;
      const storeName = item.storeName;
      const catQty = item.catQty;
      const userName = item.userName;

      const department = result.find(
        (dep: { department: any }) => dep.department === departmentKey
      );

      if (!department) {
        result.push({ department: departmentKey, qty: [], categories: [] });
      }

      const departmentIndex = result.findIndex(
        (dep: { department: any }) => dep.department === departmentKey
      );
      const category = result[departmentIndex].categories.find(
        (cat: { cname: any }) => cat.cname === categoryName
      );

      if (!category) {
        result[departmentIndex].categories.push({ cname: categoryName, qty: [] });
      }

      const categoryIndex = result[departmentIndex].categories.findIndex(
        (cat: { cname: any }) => cat.cname === categoryName
      );
      // Legacy always keys by employee (userName), never by store.
      const storeIndex = result[departmentIndex].qty.findIndex(
        (q: { UserName: any }) => q.UserName === userName
      );

      if (storeIndex === -1) {
        result[departmentIndex].qty.push({ store: storeName, qty: catQty, UserName: userName });
      } else {
        result[departmentIndex].qty[storeIndex].qty += catQty;
      }

      result[departmentIndex].categories[categoryIndex].qty.push({
        store: storeName,
        qty: catQty,
        UserName: userName,
      });

      return result;
    }, []);
  }

  runReport() {
    this.reportHasRun = true;
    this.updateChart();
  }
}
